// extracted by mini-css-extract-plugin
export default {"wrapper":"authorModal_wrapper__t0BP6","content":"authorModal_content__ltkmN","close_window":"authorModal_close_window__QpYha"};